<template>
  <section id="servicios" class="section-padding bg-background-secondary">
    <div class="max-w-7xl mx-auto">
      <!-- Header -->
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-5xl font-bold mb-6">
          Nuestros <span class="text-gradient">Servicios</span>
        </h2>
        <p class="text-xl text-muted-foreground max-w-3xl mx-auto">
          Ofrecemos soluciones tecnológicas integrales diseñadas específicamente 
          para las necesidades de Empresas Mexicanas en crecimiento.
        </p>
      </div>

      <!-- Services Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
        <div 
          v-for="(service, index) in services"
          :key="index"
          class="card-forza group h-full p-6"
        >
          <div class="pb-4">
            <div class="w-12 h-12 rounded-lg bg-gradient-to-r from-primary to-primary/60 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
              <component :is="service.icon" class="w-6 h-6 text-white" />
            </div>
            <h3 class="text-xl font-semibold group-hover:text-primary transition-colors duration-300 mb-2">
              {{ service.title }}
            </h3>
            <p class="text-muted-foreground mb-4">
              {{ service.description }}
            </p>
          </div>
          
          <div>
            <ul class="space-y-2 mb-6">
              <li 
                v-for="(feature, idx) in service.features"
                :key="idx"
                class="flex items-center text-sm"
              >
                <div class="w-1.5 h-1.5 bg-primary rounded-full mr-3"></div>
                {{ feature }}
              </li>
            </ul>
            
            <button
              @click="openCalendar"
              class="w-full group-hover:bg-primary/10 group-hover:text-primary transition-colors duration-300 inline-flex items-center justify-center px-4 py-2 rounded-md hover:bg-accent cursor-pointer relative z-10"
              style="pointer-events: auto;"
            >
              Más información
              <ArrowRight class="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </div>

      <!-- CTA Section -->
      <div class="text-center">
        <div class="inline-flex items-center justify-center p-8 bg-gradient-to-r from-primary/10 to-primary/5 rounded-2xl border border-primary/20">
          <div class="text-center">
            <h3 class="text-2xl font-semibold mb-4">
              ¿Necesitas una solución personalizada?
            </h3>
            <p class="text-muted-foreground mb-6">
              Contacta con nuestros expertos para una consulta gratuita
            </p>
            <button
              @click="openCalendar"
              class="btn-primary cursor-pointer relative z-10"
              style="pointer-events: auto;"
            >
              Agendar consulta gratuita
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { 
  Brain, 
  Code, 
  Cloud, 
  Shield, 
  BarChart3,
  ArrowRight 
} from 'lucide-vue-next'

const services = [
  {
    icon: Brain,
    title: "Consultoría Estratégica",
    description: "Transformamos tu visión en roadmap tecnológico",
    features: [
      "Auditorías TI integrales",
      "Hoja de ruta tecnológica",
      "Gestión del cambio",
      "Optimización de procesos"
    ]
  },
  {
    icon: Code,
    title: "Desarrollo & Implementación",
    description: "Soluciones a medida que impulsan tu negocio",
    features: [
      "Aplicaciones web y móviles",
      "Sistemas ERP/CRM",
      "WMS y logística",
      "Integraciones API"
    ]
  },
  {
    icon: Cloud,
    title: "Infraestructura & Cloud",
    description: "Migra a la nube con confianza y seguridad",
    features: [
      "Microsoft Azure",
      "Amazon AWS",
      "Migraciones cloud",
      "DevOps y CI/CD"
    ]
  },
  {
    icon: Shield,
    title: "Ciberseguridad",
    description: "Protege tu negocio contra amenazas digitales",
    features: [
      "Auditorías de seguridad",
      "Gestión de identidades (IAM)",
      "Monitoreo de seguridad 24/7",
      "Planes de recuperación"
    ]
  },
  {
    icon: BarChart3,
    title: "BI & Analítica",
    description: "Convierte datos en decisiones inteligentes",
    features: [
      "Microsoft Power BI",
      "Microsoft Fabric",
      "Data Warehouses",
      "Dashboards ejecutivos"
    ]
  }
]

const openCalendar = () => {
  window.open('https://calendar.app.google/sm14g81D1o1j4peJ6', '_blank')
}
</script>